import { observer } from 'mobx-react-lite';

import { XStack, YStack } from '@/components/ui/layout/layout';

import { ckDebugStore } from './ck-debug.store';
import { CkDebugDetailPanel } from './components/ck-debug-detail-panel';
import { CkDebugEventTable } from './components/ck-debug-event-table';
import { CkDebugMetricCards } from './components/ck-debug-metric-cards';
import { CkDebugToolbar } from './components/ck-debug-toolbar';

export const CkDebug = observer(() => {
  const selectedSnapshot = ckDebugStore.selectedSnapshot;

  return (
    <YStack className="h-full overflow-hidden">
      <CkDebugToolbar />
      <CkDebugMetricCards />
      <XStack className="flex-1 min-h-0">
        <div className="flex-1 min-w-0 overflow-hidden">
          <CkDebugEventTable />
        </div>
        {selectedSnapshot && (
          <div className="w-[380px] border-l border-border overflow-y-auto shrink-0">
            <CkDebugDetailPanel snapshot={selectedSnapshot} />
          </div>
        )}
      </XStack>
    </YStack>
  );
});
